import React from 'react';

import { IQuickMenu } from 'types';
import * as PreviewStyle from './style';

interface Props {
  data: IQuickMenu[];
}

const MENU_ITEMS = [
  '신청 내역',
  '내 관심 봉사',
  '내 정보 확인',
  '자주 묻는 질문',
];

function Preview({ data }: Props) {
  const active = data.filter((q) => q.isActive);

  return (
    <div css={PreviewStyle.screen}>
      <section css={PreviewStyle.section}>
        <p css={PreviewStyle.name}>홍길동 님</p>
        <p css={PreviewStyle.label}>봉사 성과</p>
        <div css={PreviewStyle.statRow}>
          <div css={PreviewStyle.stat}>
            <p>참여 봉사 수</p>
            <strong>0</strong>
          </div>
          <div css={PreviewStyle.stat}>
            <p>함께한 시간</p>
            <strong>0</strong>
          </div>
        </div>
      </section>

      <section css={PreviewStyle.section}>
        {active.length === 0 ? (
          <p css={PreviewStyle.empty}>노출 중인 퀵메뉴가 없습니다</p>
        ) : (
          <div css={PreviewStyle.grid}>
            {active.map((q) => (
              <div key={q.id} css={PreviewStyle.item}>
                <img src={q.iconUrl} alt={q.title} />
                <p>{q.title}</p>
              </div>
            ))}
          </div>
        )}
      </section>

      <section css={[PreviewStyle.section, { padding: 0 }]}>
        {MENU_ITEMS.map((title) => (
          <div key={title} css={PreviewStyle.menuItem}>
            <p>{title}</p>
            <span>›</span>
          </div>
        ))}
      </section>
    </div>
  );
}

export default Preview;
